import React from "react";
import PropTypes from "prop-types";
import TextFieldProps from "./TextField.types";
import { SearchIcon } from "../../icons";
import { StyledLabel, InputWrapper, SearchIconHolder, StyledTextField } from "./TextField.styles";

/**
 * BW TextField component.
 */
const TextField = React.forwardRef<HTMLInputElement, React.PropsWithChildren<TextFieldProps>>((props, ref) => {
    const { id, name, variant, labelText, labelType, labelStyle, error, disabled, ...rest } = props;
    return (
        <>
            {/* TODO: We will extract the label and create a shared FormLabel component */}
            {labelText && (
                <StyledLabel htmlFor={id ?? name} labelType={labelType} style={labelStyle} error={error}>
                    {labelText}
                </StyledLabel>
            )}
            <InputWrapper error={error} disabled={disabled} variant={variant}>
                {variant === "search" && (
                    <SearchIconHolder>
                        <SearchIcon width="100%" height="100%" />
                    </SearchIconHolder>
                )}
                <StyledTextField
                    id={id ?? name}
                    name={name}
                    tabIndex={disabled ? -1 : 0}
                    variant={variant}
                    ref={ref}
                    {...rest}
                />
            </InputWrapper>
        </>
    );
});

TextField.defaultProps = {
    type: "text"
};

TextField.propTypes = {
    variant: PropTypes.oneOf(["search"]),
    labelText: PropTypes.string,
    labelType: PropTypes.oneOf(["frame"]),
    labelStyle: PropTypes.object,
    error: PropTypes.bool
};

TextField.displayName = "TextField";

export default TextField;
